// @flow
import {
	connectWebActions,
	connectWebComponents,
	autoTitleLinksWithBlankTarget,
} from 'fg-frontend';
import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';
import cookiesPolicy from './components/CookiesPolicy4/index';
import phoneLink from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
autoTitleLinksWithBlankTarget();
cookiesPolicy();
phoneLink();



// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/configureWeb.js